import styled from '@emotion/styled';
import {mq} from '@styles/helpers';
import {Devices} from '@styles/tokens';

export const Wrapper = styled.div<{start?:boolean}>`
    min-height: calc(100vh - 50px);
    height:100%;
    width:100vw;
    padding:30px 30px 30px 30px;
    display:flex;
`; 

export const SplashCentent = styled.div`
    padding:20px;
    box-shadow: 0 0 4px 1px rgba(0,0,0,0.25);
    font-size: 16px;
    border-radius: 5px;
    font-weight: 500;
`; 

export const NavContainer = styled.div`
    position: absolute;
    top:30px;
    left:30px;
    height:24px;
    display:flex;
    align-items: center;
    gap:20px;

    svg{
        height:100%;
        path{
            fill:#727272;
        }
    }
`; 

export const Container = styled.div`
    width:100%;
    max-width: 600px;
    margin:0 auto;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`; 

export const TopText = styled.div`
    color:#0f0f0f;
    font-size: 24px;
    font-weight: 600;
    padding:50px; 
    text-align: center;

    ${mq(Devices.mobile)}{
        padding:6vw 2vw;
        font-size: 5.5vw;
        min-height:10vh;
    }
`; 

export const BottomText = styled.div`
    color:#0f0f0f;
    font-size: 30px;
    padding:20px;
    text-align: center;
    display:flex;
    flex-direction: column;
    align-items: center;

    ${mq(Devices.mobile)}{
        padding:6vw 2vw;
        font-size: 5vw;
    }
`; 

export const MiddleContainer = styled.div`
    border-radius:30px;
    overflow:hidden;
    width:100%;
    max-width: 400px;
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding:20px 0;
    height:100%;

    svg{
        width:30%;
    }

    p{
        font-size: 22px;
        font-weight: 600;
        margin-top: 10px; 
        text-align: center;
        padding:0 10px;
    }
    span{
        display:block;
        font-size: 16px;
    }

    ${mq(Devices.mobile)}{
        svg{
            width:30%;
        }

        p{
            font-size: 5.6vw;
            font-weight: 600;
            margin-top: 10px;
        }
        span{
            font-size: 4.5vw;
        }
    }
`;

export const LottieContent = styled.div`
    width:80%;
    margin-top: -20%;
`;

export const QRContainer = styled.div`
    border-radius: 30px;
    overflow: hidden;
    width:80%;
    max-width: 400px;
    aspect-ratio: 1 / 1.3;
    background:#fff;
    position: relative;
    

    > section > div{
        position: unset !important;
    }
    
`;

export const CodeContainer = styled.div`
    width:100%;
    max-width: 400px;
    position: relative;
`;

export const QRContainerBorder = styled.div`
    position: absolute;
    top:0; 
    left:0;
    bottom:0;
    right:0;
    border:20px solid #e2e2e285;
    z-index: 10;
    border-radius: 30px;
    
`;


export const Tags = styled.div<{pad?:boolean, disableText?:boolean}>`
    width:100%;
    display:inline-flex;
    flex-wrap: wrap;
    gap:6px 12px;
    margin-top: ${props => props.pad?"auto":"6px"};
    padding:${props => props.disableText?"8px 12px":props.pad?"0 12px 8px 12px":"unset"};

`; 

export const Row = styled.div<{space?:boolean}>`
    margin-top: ${props => props.space?"auto":"unset"};
    width:100%;
    padding:10px 0 0 0;
`; 


export const ButtonControls = styled.div`
    width:100%;
    display:flex;
    gap:20px;
    justify-content: center;
    padding:20px 0 20px 0;

    > div {
        border-radius: 30px;
        font-size:20px;
        padding:6px 32px !important;
        width:50%;
    }
`; 